import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Checkbox } from "antd";
import { useForm, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Tag } from "antd";
import styled from "styled-components";

import { PlusIcon } from "icons";
import { Checkbox2 as CheckboxCustom, Select } from "components";
import { classListFilterDataResponse } from "redux/messagemanagement/classfilterlist/classFilterListStates";
import { IOption } from "components/select/Select";
import { AttendanceFilterData } from "models/messagemanagement/attendanceFilterList";
import { localStorageHelper } from "utils";

import {
  TopSearchCondition,
  ContentSearchCondition,
  SelectStyled,
  WrapperCollapse,
  SendAllStudentBtn,
  WrapperSearchCondition,
  SearchButton,
  SearchButtonContainer,
  SendAllStudentBtnContainer,
  CheckboxStyled,
  FilterWrapper,
  OptionsWrapper,
  CustomBadgeWrapper,
} from "./MessageDelivery.style";
import { FormStatus } from "./MessageDelivery";

const StyledTag = styled(Tag)`
  width: max-content;
  height: 19px;
  border-radius: 4px;
  padding: 3px 4px 4px;
  background: #ffffff;
  border: none;
  font-size: 12px;
  line-height: 12px;
  z-index: 10;
  .ant-tag-close-icon {
    font-size: 12px;
    color: #3b3b3b;
    margin-left: 4px;
  }
`;

export const useClickOutsideHandler = (
  setIsSelectOpen: (open: boolean) => void,
  enable = true
) => {
  useEffect(() => {
    const badgeWrapper = document.getElementById("custom-badge");
    // const popupBlock = document.getElementsByClassName("ant-select-multiple");
    const popupBlock1 = document.getElementsByClassName("dropdown-render");
    const popupBlock2 = document.getElementsByClassName("ant-checkbox-wrapper");
    function handleClickOutside(event: any) {
      if (enable) {
        if (
          // popupBlock &&
          // popupBlock.length &&
          popupBlock1 &&
          popupBlock1.length &&
          popupBlock2 &&
          popupBlock2.length &&
          // !popupBlock[0].contains(event.target) &&
          !popupBlock1[0].contains(event.target) &&
          !badgeWrapper?.contains(event.target) &&
          popupBlock1[0].getElementsByClassName("ant-checkbox-wrapper")
            .length &&
          !popupBlock1[0]
            .getElementsByClassName("ant-checkbox-wrapper")[0]
            .contains(event.target)
          // clickIcon &&
          // event.target !== clickIcon
        ) {
          setIsSelectOpen(false);
        }
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [enable]);
};
interface ISearchCondition {
  showModal: (formStatus: FormStatus) => void;
  onSubmit: (data: any) => void;
  handleSendToAllUser: (value: boolean) => void;
  setDatas: any;
  datas: any;
}

const currentYear = new Date().getFullYear();
export const yearOptions: any = [
  {
    id: 0,
    value: "",
    name: "----",
  },
];
for (let i = currentYear; i >= 1900; i--) {
  yearOptions.push({
    id: i,
    value: i,
    name: i,
  });
}

export const monthOptions: any = [
  {
    id: 0,
    value: "",
    name: "--",
  },
];
for (let i = 1; i <= 12; i++) {
  if (i <= 9) {
    monthOptions.push({
      id: i,
      value: i,
      name: `0${i}`,
    });
  } else {
    monthOptions.push({
      id: i,
      value: i,
      name: i,
    });
  }
}

const dayOptionsDefault: any = [
  {
    id: 0,
    value: "",
    name: "--",
  },
];
for (let i = 1; i <= 31; i++) {
  if (i <= 9) {
    dayOptionsDefault.push({
      id: i,
      value: i,
      name: `0${i}`,
    });
  } else {
    dayOptionsDefault.push({
      id: i,
      value: i,
      name: i,
    });
  }
}

const genderOptions = [
  {
    id: 0,
    value: 0,
    name: "男性",
  },
  {
    id: 1,
    name: "女性",
    value: 1,
  },
  {
    id: 2,
    name: "回答なし",
    value: 2,
  },
];

const SearchCondition: React.FC<ISearchCondition> = (props) => {
  const { showModal, onSubmit, handleSendToAllUser, setDatas, datas } = props;

  const { t }: any = useTranslation("translation", {
    keyPrefix: "message-delivery",
  });
  const { t: t1 }: any = useTranslation("translation", {
    keyPrefix: "user-list",
  });

  const dispatch = useDispatch();
  const currentLanguage = localStorageHelper.getItem("i18nextLng");

  const { watch, handleSubmit, control, setValue } = useForm();
  const watchStartYear = watch("startYear");
  const watchEndYear = watch("endYear");
  const watchStartMonth = watch("startMonth");
  const watchEndMonth = watch("endMonth");
  const watchStartDate = watch("startDate");
  const watchEndDate = watch("endDate");

  const [activityValue, setActivityValue] = useState<any>([]);
  const [valueCheckedGender, setValueCheckedGender] = useState<any>([]);
  const [checkAll, setCheckAll] = useState(false);
  const [checkedGrade, setCheckedGrade] = useState<any>(false);
  const [isDisabled, setIsDisabled] = useState<{
    class: boolean;
    activities: boolean;
  }>({
    class: false,
    activities: false,
  });
  const [isDisabledSelect, setIsDisabledSelect] = useState<boolean>(true);
  const [endYearOptions, setEndYearOptions] = useState([]);
  const [endMonthOptions, setEndMonthOptions] = useState([]);
  const [startMonthOptions, setStartMonthOptions] = useState([]);
  const [startDayOptions, setStartDayOptions] = useState(dayOptionsDefault);
  const [endDayOptions, setEndDayOptions] = useState(dayOptionsDefault);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [closeTag, setCloseTag] = useState(false);

  useClickOutsideHandler(setDropdownOpen);

  const daysOfStartMonth = useMemo<number>(() => {
    return moment(
      `${watchStartYear}-${watchStartMonth}`,
      "YYYY-MM"
    ).daysInMonth();
  }, [watchStartYear, watchStartMonth]);

  const daysOfEndMonth = useMemo<number>(() => {
    return moment(
      `${watchEndYear || watchStartYear}-${watchEndMonth}`,
      "YYYY-MM"
    ).daysInMonth();
  }, [watchEndYear, watchEndMonth, watchStartYear]);

  const startDate = useMemo<string>(() => {
    if (watchStartYear) {
      return moment(
        `${watchStartYear}-${watchStartMonth || "01"}-${watchStartDate || "01"}`
      ).format("YYYY-MM-DD");
      // )format("YYYY-MM-DD");
    } else return "";
  }, [watchStartYear, watchStartMonth, watchStartDate]);

  const endDate = useMemo<string>(() => {
    if (watchEndYear) {
      return moment(
        `${watchEndYear}-${watchEndMonth || "12"}-${
          watchEndDate || daysOfEndMonth
        }`
      ).format("YYYY-MM-DD");
    } else {
      // if (watchStartYear) {
      //   return moment(
      //     `${watchStartYear}-${watchEndMonth || "12"}-${watchEndDate || daysOfEndMonth
      //     }`
      //   ).toString();
      // } else return "";
      // return moment(new Date()).format("YYYY-MM-DD");
      return "";
    }
  }, [watchEndYear, watchEndMonth, watchEndDate]);

  useEffect(() => {
    setDatas((prevData: any) => ({ ...prevData, from_date: startDate }));
    setDatas((prevData: any) => ({ ...prevData, to_date: endDate }));
    // if (startDate) {
    // }
    // if (endDate) {
    // }
    //  else {
    //   setDatas((prevData: any) => ({ ...prevData, to_date: moment(new Date()).format("YYYY-MM-DD") }));
    // }
  }, [startDate, endDate]);

  const resetEndDate = () => {
    setValue("endYear", undefined);
    setValue("endMonth", undefined);
    setValue("endDate", undefined);
  };

  const handleOptions = (num: number, current?: any) => {
    const arr: any = [
      {
        id: 0,
        value: "",
        name: "--",
      },
    ];

    for (let i = 1; i <= num; i++) {
      if (i <= 9) {
        let item: any = {
          id: i,
          value: i,
          name: `0${i}`,
        };
        if (current) {
          item = {
            ...item,
            disabled: current <= i ? false : true,
          };
        }
        arr.push(item);
      } else {
        let item: any = {
          id: i,
          value: i,
          name: i,
        };
        if (current) {
          item = {
            ...item,
            disabled: current <= i ? false : true,
          };
        }
        arr.push(item);
      }
    }

    return arr;
  };

  const handleOptions2 = (num: number, current?: any) => {
    const arr: any = [
      {
        id: 0,
        value: "",
        name: "--",
      },
    ];

    for (let i = 1; i <= num; i++) {
      if (i <= 9) {
        let item: any = {
          id: i,
          value: i,
          name: `0${i}`,
        };
        if (current) {
          item = {
            ...item,
            disabled: current >= i ? false : true,
          };
        }
        arr.push(item);
      } else {
        let item: any = {
          id: i,
          value: i,
          name: i,
        };
        if (current) {
          item = {
            ...item,
            disabled: current >= i ? false : true,
          };
        }
        arr.push(item);
      }
    }

    return arr;
  };
  const handleOptions3 = (num: number, current?: any, max?: any) => {
    const arr: any = [
      {
        id: 0,
        value: "",
        name: "--",
      },
    ];

    for (let i = 1; i <= num; i++) {
      if (i <= 9) {
        let item: any = {
          id: i,
          value: i,
          name: `0${i}`,
        };
        if (current) {
          item = {
            ...item,
            disabled: current <= i && i <= max ? false : true,
          };
        }
        arr.push(item);
      } else {
        let item: any = {
          id: i,
          value: i,
          name: i,
        };
        if (current) {
          item = {
            ...item,
            disabled: current <= i && i <= max ? false : true,
          };
        }
        arr.push(item);
      }
    }

    return arr;
  };

  const handleGetFirstDateOfMonth = (year: number, month: number) => {
    const firstDay = new Date(year, month, 1);
    return moment(firstDay).format("YYYY-MM-DD");
  };

  const handleGetLastDateOfMonth = (year: number, month: number) => {
    const lastDay = new Date(year, month, 0);
    return moment(lastDay).format("YYYY-MM-DD");
  };

  const onSubmit2 = (data: any) => {
    let fromDate = "";
    let toDate = "";

    if (data.startYear && !data.startMonth && !data.startDate) {
      fromDate = handleGetFirstDateOfMonth(data.startYear, 0);
    }

    if (data.startMonth && !data.startDate) {
      fromDate = handleGetFirstDateOfMonth(data.startYear, data.startMonth - 1);
      // toDate = handleGetLastDateOfMonth(data.startYear, data.startMonth);
    }

    if (data.startYear && data.startMonth && data.startDate) {
      fromDate = moment(
        `${data.startYear}-${data.startMonth}-${data.startDate}`
      ).format("YYYY-MM-DD");
      // toDate = handleGetLastDateOfMonth(data.startYear, data.startMonth);
    }

    if (!data.endYear && data.startYear) {
      // if (!data.endMonth && !data.endDate) {
      //   if (data.startMonth && !data.startDate) {
      //     toDate = handleGetLastDateOfMonth(data.startYear, data.startMonth);
      //   } else if (data.startMonth && data.startDate) {
      //     toDate = moment(fromDate).add(1, "day").format("YYYY-MM-DD");
      //     // toDate = fromDate;
      //   } else {
      //     toDate = moment(new Date()).format("YYYY-MM-DD");
      //   }
      // } else if (data.endMonth && !data.endDate) {
      //   toDate = handleGetLastDateOfMonth(data.startYear, data.endMonth);
      // } else {
      //   toDate = moment(
      //     `${data.startYear}-${data.endMonth}-${data.endDate}`
      //   ).format("YYYY-MM-DD");
      // }
      toDate = moment(new Date()).format("YYYY-MM-DD");
    }
    if (data.endYear && data.endYear >= data.startYear) {
      if (!data.endMonth && !data.endDate) {
        toDate = handleGetLastDateOfMonth(data.endYear, 12);
      } else if (data.endMonth && !data.endDate) {
        toDate = handleGetLastDateOfMonth(data.endYear, data.endMonth);
      } else {
        toDate = moment(
          `${data.endYear}-${data.endMonth}-${data.endDate}`
        ).format("YYYY-MM-DD");
      }
    }
    // if (data.startYear && data.endYear) {
    //   if (!data.startMonth && !data.endMonth) {
    //     fromDate = handleGetFirstDateOfMonth(data.startYear, 0);
    //     toDate = handleGetLastDateOfMonth(data.endYear, 12);
    //   } else {
    //     fromDate = handleGetFirstDateOfMonth(
    //       data.startYear,
    //       data.startMonth - 1
    //     );
    //     toDate = handleGetLastDateOfMonth(data.endYear, data.endMonth);
    //   }

    //   if (!data.startMonth && data.endMonth) {
    //     fromDate = handleGetFirstDateOfMonth(data.startYear, 0);
    //     toDate = handleGetLastDateOfMonth(data.endYear, data.endMonth);
    //   }

    //   if (data.startMonth && !data.endMonth) {
    //     fromDate = handleGetFirstDateOfMonth(
    //       data.startYear,
    //       data.startMonth - 1
    //     );
    //     toDate = handleGetLastDateOfMonth(data.endYear, 12);
    //   }
    // }

    const params: any = {
      page: 1,
      user_name: data.name,
      // per_page: input.per_page,
      from_date: fromDate,
      to_date: toDate,
    };

    // if (fromDate || toDate || data.name) {
    //   setIsSearching(true);
    // } else {
    //   setIsSearching(false);
    // }

    // dispatch(GetPatientsActionCreators.getPatientListAction(params));
    // setInput(params);
  };

  const handleOnChangeGender = (value: IOption[]) => {
    setDropdownOpen(true);
    setDatas((prevData: any) => ({ ...prevData, genders: value }));
    setValueCheckedGender(value);
    if (value) {
      const temp = value.map((value) => {
        return genderOptions.find((option: any) => option.value === value)
          ?.name;
      });
      setActivityValue(temp);
    }
  };

  const handleRemove = (val: any) => {
    setCloseTag(true);
    const idx = genderOptions.findIndex((option: any) => option.name === val);
    if (idx >= 0) {
      const tempGender = [...valueCheckedGender].filter(
        (gender: any) => gender !== idx
      );
      setActivityValue(activityValue.filter((item: any) => item !== val));
      setDatas((prevData: any) => ({ ...prevData, genders: tempGender }));
      setValueCheckedGender(tempGender);
    }
  };

  useEffect(() => {
    if (closeTag) {
      setCloseTag(false);
    }
  }, [valueCheckedGender]);

  const basicConditionItems = {
    key: 1,
    label: "性別",
    name: "gender",
    options: genderOptions,
    marginForm: "0 0 32px",
    value: activityValue,
    checkedValue: valueCheckedGender,
    onChange: handleOnChangeGender,
  };

  const enabledSearchButton = useMemo(() => {
    let check = false;
    for (const property in datas) {
      if (datas[property].length) {
        if (property === "grades") {
          if (checkedGrade) {
            check = true;
          }
        } else {
          check = true;
        }
      }
    }
    return check;
  }, [datas]);

  useEffect(() => {
    if (watchStartYear) {
      setIsDisabledSelect(false);
      resetEndDate();
      setValue("startDate", undefined);
      setValue("startMonth", undefined);

      // if (
      //   moment(`${watchStartYear}-02`).daysInMonth() < 29 &&
      //   watchStartDate &&
      //   watchStartDate === 29
      // ) {
      //   setValue("startDate", undefined);
      // }

      if (watchStartYear !== watchEndYear) {
        if (watchEndYear && watchEndYear > watchStartYear) {
          setEndMonthOptions(monthOptions);
        } else {
          const endMonthOptionsClone: any = [
            {
              id: 0,
              value: "",
              name: "--",
            },
          ];
          if (watchStartDate && watchStartDate === daysOfStartMonth) {
            for (let i = 1; i <= 12; i++) {
              if (i <= 9) {
                endMonthOptionsClone.push({
                  id: i,
                  value: i,
                  name: `0${i}`,
                  disabled: i < watchStartMonth + 1 ? true : false,
                });
              } else {
                endMonthOptionsClone.push({
                  id: i,
                  value: i,
                  name: i,
                  disabled: i < watchStartMonth + 1 ? true : false,
                });
              }
            }
          } else {
            for (let i = 1; i <= 12; i++) {
              if (i <= 9) {
                endMonthOptionsClone.push({
                  id: i,
                  value: i,
                  name: `0${i}`,
                  disabled: i < watchStartMonth ? true : false,
                });
              } else {
                endMonthOptionsClone.push({
                  id: i,
                  value: i,
                  name: i,
                  disabled: i < watchStartMonth ? true : false,
                });
              }
            }
          }

          setEndMonthOptions(endMonthOptionsClone);
        }
      } else {
        const endMonthOptionsClone: any = [
          {
            id: 0,
            value: "",
            name: "--",
          },
        ];

        if (watchStartDate && watchStartDate === daysOfStartMonth) {
          for (let i = 1; i <= 12; i++) {
            if (i <= 9) {
              endMonthOptionsClone.push({
                id: i,
                value: i,
                name: `0${i}`,
                disabled: i < watchStartMonth + 1 ? true : false,
              });
            } else {
              endMonthOptionsClone.push({
                id: i,
                value: i,
                name: i,
                disabled: i < watchStartMonth + 1 ? true : false,
              });
            }
          }
        } else {
          for (let i = 1; i <= 12; i++) {
            if (i <= 9) {
              endMonthOptionsClone.push({
                id: i,
                value: i,
                name: `0${i}`,
                disabled: i < watchStartMonth ? true : false,
              });
            } else {
              endMonthOptionsClone.push({
                id: i,
                value: i,
                name: i,
                disabled: i < watchStartMonth ? true : false,
              });
            }
          }
        }

        setEndMonthOptions(endMonthOptionsClone);
      }

      const endYearOptionsClone: any = [
        {
          id: 0,
          value: "",
          name: "----",
        },
      ];

      if (
        watchStartMonth &&
        watchStartMonth === 12 &&
        watchStartDate &&
        watchStartDate === daysOfStartMonth
      ) {
        for (let i = currentYear; i >= 1900; i--) {
          endYearOptionsClone.push({
            id: i,
            value: i,
            name: i,
            disabled: i < watchStartYear + 1 ? true : false,
          });
        }
      } else {
        for (let i = currentYear; i >= 1900; i--) {
          endYearOptionsClone.push({
            id: i,
            value: i,
            name: i,
            disabled: i < watchStartYear ? true : false,
          });
        }
      }
      // const dayClone = handleOptions(daysOfStartMonth);

      // setStartDayOptions(dayClone);

      if (watchStartYear === moment(new Date()).year()) {
        const currentMonth = moment(new Date()).month(); //month based on index
        const startMonthOptionsClone: any = [
          {
            id: 0,
            value: "",
            name: "--",
          },
        ];
        for (let i = 1; i <= 12; i++) {
          if (i <= 9) {
            startMonthOptionsClone.push({
              id: i,
              value: i,
              name: `0${i}`,
              disabled: i > currentMonth + 1 ? true : false,
            });
          } else {
            startMonthOptionsClone.push({
              id: i,
              value: i,
              name: i,
              disabled: i > currentMonth + 1 ? true : false,
            });
          }
        }
        setStartMonthOptions(startMonthOptionsClone);
      } else {
        setStartMonthOptions(monthOptions);
      }
      setEndYearOptions(endYearOptionsClone);
    } else {
      setIsDisabledSelect(true);
      setValue("startMonth", undefined);
      // setValue("endYear", undefined);
      // setValue("endMonth", undefined);
      resetEndDate();
    }
  }, [watchStartYear]);

  useEffect(() => {
    // if (isResetEndDate) {
    //   setValue("startMonth", undefined);
    //   setValue("startDate", undefined);
    // }
    setValue("endDate", undefined);
    setValue("endMonth", undefined);
    const endMonthOptionsClone: any = [
      {
        id: 0,
        value: "",
        name: "--",
      },
    ];

    if (
      !watchEndYear ||
      (watchEndYear &&
        (watchStartYear === watchEndYear || watchEndYear === moment().year()))
    ) {
      if (watchStartYear === moment().year()) {
        for (let i = 1; i <= 12; i++) {
          if (i <= 9) {
            endMonthOptionsClone.push({
              id: i,
              value: i,
              name: `0${i}`,
              disabled:
                i < watchStartMonth || i > moment().month() + 1 ? true : false,
            });
          } else {
            endMonthOptionsClone.push({
              id: i,
              value: i,
              name: i,
              disabled:
                i < watchStartMonth || i > moment().month() + 1 ? true : false,
            });
          }
        }
      } else if (watchEndYear && watchEndYear === moment().year()) {
        for (let i = 1; i <= 12; i++) {
          if (i <= 9) {
            endMonthOptionsClone.push({
              id: i,
              value: i,
              name: `0${i}`,
              disabled: i > moment().month() + 1 ? true : false,
            });
          } else {
            endMonthOptionsClone.push({
              id: i,
              value: i,
              name: i,
              disabled: i > moment().month() + 1 ? true : false,
            });
          }
        }
      } else {
        // const modifiedNumber =
        //   watchStartDate && watchStartDate === daysOfStartMonth ? 1 : 0;
        for (let i = 1; i <= 12; i++) {
          if (i <= 9) {
            endMonthOptionsClone.push({
              id: i,
              value: i,
              name: `0${i}`,
              disabled: i < watchStartMonth ? true : false,
            });
          } else {
            endMonthOptionsClone.push({
              id: i,
              value: i,
              name: i,
              disabled: i < watchStartMonth ? true : false,
            });
          }
        }
      }

      setEndMonthOptions(endMonthOptionsClone);
    } else {
      setEndMonthOptions(monthOptions);
    }
  }, [watchEndYear]);

  useEffect(() => {
    if (watchStartMonth) {
      resetEndDate();
      // if (isResetEndDate) {
      //   resetEndDate();
      //   }
      setValue("startDate", undefined);
      // if (
      //   watchStartDate &&
      //   moment(`${watchStartYear}-${watchStartMonth}`).daysInMonth() <
      //   watchStartDate
      // ) {
      //   setValue("startDate", undefined);
      // }
      const endMonthOptionsClone: any = [
        {
          id: 0,
          value: "",
          name: "--",
        },
      ];
      let dayClone: any[] = [];
      if (
        watchStartYear === moment().year() &&
        watchStartMonth === moment().month() + 1
      ) {
        const currentDay = moment().date();
        dayClone = handleOptions2(daysOfStartMonth, currentDay);
      } else {
        dayClone = handleOptions(daysOfStartMonth);
      }

      if (!watchEndYear || (watchEndYear && watchEndYear === watchStartYear)) {
        for (let i = 1; i <= 12; i++) {
          if (i <= 9) {
            endMonthOptionsClone.push({
              id: i,
              value: i,
              name: `0${i}`,
              disabled: i < watchStartMonth ? true : false,
            });
          } else {
            endMonthOptionsClone.push({
              id: i,
              value: i,
              name: i,
              disabled: i < watchStartMonth ? true : false,
            });
          }
        }
        setEndMonthOptions(endMonthOptionsClone);
      } else {
        setEndMonthOptions(monthOptions);
      }

      setStartDayOptions(dayClone);
    } else {
      resetEndDate();
      setValue("startDate", undefined);
    }
  }, [watchStartMonth]);

  useEffect(() => {
    if (watchEndMonth) {
      let dayClone: any[] = [];
      setValue("endDate", undefined);
      // if (
      //   watchEndDate &&
      //   moment(
      //     `${watchEndYear || watchStartYear}-${watchEndMonth}`
      //   ).daysInMonth() < watchEndDate
      // ) {
      //   setValue("endDate", undefined);
      // }
      const currentMonth = moment().month() + 1;
      const currentDay = moment().date();
      if (
        !watchEndYear ||
        (watchEndYear &&
          (watchEndYear === watchStartYear || watchEndYear === moment().year()))
      ) {
        if (!watchStartMonth && !watchStartDate) {
          if (
            watchEndMonth === currentMonth &&
            watchEndYear === moment().year()
          ) {
            dayClone = handleOptions2(daysOfEndMonth, currentDay);
          } else {
            dayClone = handleOptions(daysOfEndMonth);
          }
        }
        if (watchStartMonth && !watchStartDate) {
          if (
            watchEndMonth === currentMonth &&
            watchEndYear === moment().year()
          ) {
            dayClone = handleOptions3(daysOfEndMonth, 1, currentDay);
          } else {
            dayClone = handleOptions(daysOfEndMonth);
          }
        }
        if (watchStartMonth && watchStartDate) {
          if (watchEndMonth === watchStartMonth) {
            if (
              watchStartMonth === currentMonth &&
              watchEndYear === moment().year()
            ) {
              dayClone = handleOptions3(
                daysOfEndMonth,
                watchStartDate,
                currentDay
              );
            } else {
              dayClone = handleOptions(daysOfEndMonth, watchStartDate);
            }
          } else {
            if (
              watchEndMonth === currentMonth &&
              watchEndYear === moment().year()
            ) {
              dayClone = handleOptions2(daysOfEndMonth, currentDay);
            } else {
              dayClone = handleOptions(daysOfEndMonth);
            }
          }
        }
      } else {
        // if (watchEndYear && watchEndYear > watchStartYear && watchEndYear !==) {
        dayClone = handleOptions(daysOfEndMonth);
      }

      setEndDayOptions(dayClone);
    } else {
      setEndDayOptions([]);
      setValue("endDate", undefined);
    }
  }, [watchEndMonth, watchStartDate, watchEndYear]);

  useEffect(() => {
    resetEndDate();
    // if (isResetEndDate) {
    // }
    if (watchStartDate === daysOfStartMonth) {
      if (!watchEndYear || (watchEndYear && watchEndYear === watchStartYear)) {
        const endMonthOptionsClone: any = [
          {
            id: 0,
            value: "",
            name: "--",
          },
        ];

        for (let i = 1; i <= 12; i++) {
          if (i <= 9) {
            endMonthOptionsClone.push({
              id: i,
              value: i,
              name: `0${i}`,
              disabled: i < watchStartMonth + 1 ? true : false,
            });
          } else {
            endMonthOptionsClone.push({
              id: i,
              value: i,
              name: i,
              disabled: i < watchStartMonth + 1 ? true : false,
            });
          }
        }

        setEndMonthOptions(endMonthOptionsClone);
      }

      if (
        watchStartMonth === 12 &&
        (!watchEndYear || (watchEndYear && watchEndYear === watchStartYear))
      ) {
        const endYearOptionsClone: any = [
          {
            id: 0,
            value: "",
            name: "----",
          },
        ];
        for (let i = currentYear; i >= 1900; i--) {
          endYearOptionsClone.push({
            id: i,
            value: i,
            name: i,
            disabled: i < watchStartYear + 1 ? true : false,
          });
        }

        setEndYearOptions(endYearOptionsClone);
      }
    } else {
      if (!watchEndYear || (watchEndYear && watchEndYear === watchStartYear)) {
        const endMonthOptionsClone: any = [
          {
            id: 0,
            value: "",
            name: "--",
          },
        ];

        for (let i = 1; i <= 12; i++) {
          if (i <= 9) {
            endMonthOptionsClone.push({
              id: i,
              value: i,
              name: `0${i}`,
              disabled: i < watchStartMonth ? true : false,
            });
          } else {
            endMonthOptionsClone.push({
              id: i,
              value: i,
              name: i,
              disabled: i < watchStartMonth ? true : false,
            });
          }
        }

        setEndMonthOptions(endMonthOptionsClone);
      } else {
        setEndMonthOptions(monthOptions);
      }

      const endYearOptionsClone: any = [
        {
          id: 0,
          value: "",
          name: "----",
        },
      ];
      for (let i = currentYear; i >= 1900; i--) {
        endYearOptionsClone.push({
          id: i,
          value: i,
          name: i,
          disabled: i < watchStartYear ? true : false,
        });
      }

      setEndYearOptions(endYearOptionsClone);
    }
  }, [watchStartDate]);

  return (
    <WrapperSearchCondition>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div style={{ position: "relative" }}>
          <TopSearchCondition>
            <div>{t("search-condition")}</div>
          </TopSearchCondition>
          <ContentSearchCondition>
            <Row gutter={16}>
              <Col xs={24} md={15} xl={24}>
                <FilterWrapper>
                  <div className="birth-title">生年月日</div>
                  <Controller
                    control={control}
                    name="startYear"
                    render={({ field: { onChange, value } }) => (
                      <Select
                        width="70px"
                        options={yearOptions}
                        onChange={onChange}
                        placeholder="----"
                        value={value}
                      />
                    )}
                  />
                  <Controller
                    control={control}
                    name="startMonth"
                    render={({ field: { onChange, value } }) => (
                      <Select
                        width="56px"
                        options={startMonthOptions}
                        onChange={onChange}
                        placeholder="--"
                        value={value}
                        disabled={isDisabledSelect}
                      />
                    )}
                  />
                  <Controller
                    control={control}
                    name="startDate"
                    render={({ field: { onChange, value } }) => (
                      <Select
                        width="56px"
                        options={startDayOptions}
                        onChange={onChange}
                        placeholder="--"
                        value={value}
                        disabled={!watchStartYear || !watchStartMonth}
                      />
                    )}
                  />

                  <span className="divider-span">〜</span>
                  <Controller
                    control={control}
                    name="endYear"
                    render={({ field: { onChange, value } }) => (
                      <Select
                        className="end-year-select"
                        width="70px"
                        options={
                          endYearOptions.length ? endYearOptions : yearOptions
                        }
                        onChange={onChange}
                        placeholder="----"
                        value={value}
                        disabled={isDisabledSelect}
                      />
                    )}
                  />
                  <Controller
                    control={control}
                    name="endMonth"
                    render={({ field: { onChange, value } }) => (
                      <Select
                        width="56px"
                        options={
                          endMonthOptions.length
                            ? endMonthOptions
                            : monthOptions
                        }
                        onChange={onChange}
                        placeholder="--"
                        value={value}
                        disabled={!watchEndYear}
                      />
                    )}
                  />
                  <Controller
                    control={control}
                    name="endDate"
                    render={({ field: { onChange, value } }) => (
                      <Select
                        width="56px"
                        options={endDayOptions}
                        onChange={onChange}
                        placeholder="--"
                        value={value}
                        // disabled={!watchEndYear || !watchEndMonth}
                        disabled={!watchEndMonth}
                      />
                    )}
                  />
                </FilterWrapper>
              </Col>
              <Col xs={24} md={9} xl={24}>
                <div className="div-select" style={{ position: "relative" }}>
                  <SelectStyled
                    mode="multiple"
                    // onClick={(e: any) => {
                    //   setDropdownOpen(!dropdownOpen);
                    // }}
                    open={dropdownOpen} // Control dropdown manually
                    // onDropdownVisibleChange={(visible) => {
                    //   setDropdownOpen(visible);
                    // }}
                    value={basicConditionItems.value}
                    label={basicConditionItems.label}
                    placeholder={t1("please-select")}
                    background="#F2F2F2"
                    fsLabel={16}
                    marginForm={basicConditionItems.marginForm}
                    showSearch={false}
                    showArrow
                    tagRender={({ value, closable }) => (
                      <StyledTag
                        closable={closable}
                        onClose={(e) => {
                          e.preventDefault(); // Prevent dropdown from opening
                          e.stopPropagation();
                          handleRemove(value);
                        }}
                      >
                        {value}
                      </StyledTag>
                    )}
                    dropdownRender={() => (
                      <OptionsWrapper className="dropdown-render">
                        {/* {!idx && (
                              <CheckboxStyled
                                onChange={onCheckAllChange}
                                checked={checkAll}
                                style={{ marginBottom: 18 }}
                              >
                                {t("all")}
                              </CheckboxStyled>
                            )} */}
                        <CheckboxCustom
                          value={basicConditionItems.checkedValue}
                          list={basicConditionItems.options}
                          onChange={basicConditionItems.onChange}
                        />
                      </OptionsWrapper>
                    )}
                    suffixIcon={
                      <span
                        style={{
                          position: "absolute",
                          top: "2.5px",
                          right: "2px",
                          cursor: "pointer",
                        }}
                      >
                        <PlusIcon fill="#000" width="14px" height="14px" />
                      </span>
                    }
                  />
                  <CustomBadgeWrapper
                    id="custom-badge"
                    onClick={(e: any) => {
                      e.preventDefault();
                      e.stopPropagation();
                      if (dropdownOpen) {
                        setDropdownOpen(false);
                      } else {
                        setDropdownOpen(true);
                      }
                      // setDropdownOpen(!dropdownOpen);
                    }}
                  >
                    {basicConditionItems.value?.length ? (
                      basicConditionItems.value.map(
                        (item: any, index: number) => (
                          <StyledTag
                            key={index}
                            closable={true}
                            onClose={(e) => {
                              e.preventDefault(); // Prevent dropdown from opening
                              e.stopPropagation();
                              handleRemove(item);
                            }}
                          >
                            {item}
                          </StyledTag>
                        )
                      )
                    ) : (
                      <span
                        style={{
                          fontSize: 14,
                          color: "#bfbfbf",
                          lineHeight: "19px",
                        }}
                      >
                        選択してください
                      </span>
                    )}

                    <span
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "9px",
                        cursor: "pointer",
                      }}
                    >
                      <PlusIcon fill="#000" width="14px" height="14px" />
                    </span>
                  </CustomBadgeWrapper>
                </div>
              </Col>
            </Row>
          </ContentSearchCondition>
        </div>
        <SearchButtonContainer>
          <SearchButton
            type="submit"
            background="#2AC769"
            color="#fff"
            name={t1("search")}
            border="none"
            fontWeight={700}
            fontSize={16}
            bdr="6px"
            disabled={!valueCheckedGender.length && !watchStartYear}
          />
        </SearchButtonContainer>
      </form>
      <SendAllStudentBtnContainer>
        <SendAllStudentBtn
          name={t("send-a-message-to-all-registrants")}
          type="submit"
          background="#83BCE2"
          color="#fff"
          bdr="6px"
          border="none"
          fontWeight={700}
          fontSize={16}
          onClick={() => {
            handleSendToAllUser(true);
            showModal("sendMessage");
          }}
          // disabled={!isDisabled.class && !isDisabled.activities}
        />
      </SendAllStudentBtnContainer>
    </WrapperSearchCondition>
  );
};

export default SearchCondition;
